/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M468.578 411.479H43.422V102.521h425.156M471.434 60H40.538C18.732 60 1 77.774 1 99.63v314.74C1 436.226 18.732 454 40.538 454h430.896C493.268 454 511 436.226 511 414.37V99.63C511 77.774 493.268 60 471.434 60M81.882 331.103a21.235 21.235 0 0018.298 10.488c3.649 0 7.354-.963 10.719-2.948l79.075-46.631 53.056 40.933c3.846 2.949 8.4 4.423 12.953 4.423 4.553 0 9.107-1.474 12.896-4.394l53.311-40.934 76.926 44.59a21.014 21.014 0 0010.605 2.864c7.325 0 14.452-3.799 18.383-10.63 5.854-10.149 2.404-23.16-7.72-29.057l-61.71-35.774 60.72-46.603c9.304-7.144 11.058-20.495 3.93-29.822-7.126-9.297-20.419-11.14-29.752-3.94L256.012 289.29 115.904 181.174c-9.361-7.172-22.597-5.386-29.78 3.883-7.127 9.298-5.402 22.65 3.874 29.793l63.746 49.211-64.312 37.93c-10.124 5.952-13.49 18.992-7.55 29.112"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconMail = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconMail.defaultProps = {
  theme,
};
IconMail.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconMail.displayName = 'IconMail';
export { IconMail };
